
import Vue from 'vue'
// import matrixTransformer from '@/transformers/catalogs/matrix'

/**
 * @author José Luis Ruiz
 * @param id Sinister Id
 * @return {Object}
 */

export default ({ id }) => {
  return Vue.$http.get(`sinister/re_execute_auth_matrix/${id}/`)
    .then(({ data }) => data)
}
